import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoadingDisplayService} from '../services/loading-display.service';
import {finalize} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadingInterceptorService {

  constructor(private loadingDisplayService: LoadingDisplayService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loadingDisplayService.addRequest();
    return next.handle(req).pipe(finalize(() => this.loadingDisplayService.removeRequest()));
  }

}
